var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"z-10 p-5 bg-white border rounded-lg border-default-100 2xl:w-full lg:p-6 xl:p-8 print:border-none dark:bg-gray-900 dark:border-gray-800"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }